import React from "react";
import ExlyImage from "common/Components/ExlyImage";
import styles from "./SectionLockedStyles.module.css";
import { locked_svg } from "./constants/SectionLocked.constants";
import { COMMON_WIDTH_RESOLUTIONS } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";

export const SectionLocked = () => {
  return (
    <ExlyImage
      className={styles.lockedIcon}
      src={locked_svg}
      fetchWidth={COMMON_WIDTH_RESOLUTIONS.WIDTH_360}
    />
  );
};
